// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-card {
  width: calc(33% - 0.75rem);
  background: var(--white);
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
  border-radius: 0.5rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
@media (max-width: 768px) {
  .store-card {
    width: 100%;
  }
}
.store-card-image {
  width: 100%;
  height: 310px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.store-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.5rem 0.5rem 0 0;
}
.store-card-image img.preview {
  width: 4rem;
  height: 4rem;
}
.store-card-more {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 5rem;
}
@media (max-width: 768px) {
  .store-card-more {
    margin-bottom: 5rem;
  }
}
.store-card-more-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  margin-bottom: 0.5rem;
  margin-top: 1.5rem;
}
.store-card-more-description {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: var(--black4);
  text-align: center;
}
.store-card-footer {
  padding: 1rem;
  border-top: 1px solid var(--black2);
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.store-card-footer-name {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  margin-bottom: 0.25rem;
}
.store-card-footer-version {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: var(--black5);
}
.store-card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
}
.more-buttons {
  position: relative;
  cursor: pointer;
}
@media (max-width: 768px) {
  .more-buttons {
    position: static;
  }
}

.themes-buttons-dropdown {
  position: absolute;
  bottom: calc(100% + 0.5rem);
  min-width: 250px;
  max-width: 500px;
  width: 100%;
  background: var(--white);
  border-radius: 0.5rem;
  box-shadow: 0 4px 24px -4px rgba(18, 20, 23, 0.08);
  right: 0;
  padding: 0.5rem;
  display: none;
  z-index: 9;
}
.themes-buttons-dropdown.open {
  display: flex;
  flex-direction: column;
}
.themes-buttons-dropdown button {
  width: 100%;
  border: none;
  margin: 0 !important;
  box-shadow: none !important;
  align-items: center;
  justify-content: flex-start;
}
.themes-buttons-dropdown button.delete-icon {
  color: var(--red6);
}
.themes-buttons-dropdown button.delete-icon svg * {
  stroke: var(--red6);
}
.themes-buttons-dropdown button.delete-icon:hover {
  background: var(--red0);
}
.themes-buttons-dropdown button svg {
  margin-right: 0.5rem;
}
.themes-buttons-dropdown button:hover {
  background: var(--black1);
}
.themes-buttons-dropdown button:hover img {
  display: block;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/customization/store/index.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,wBAAA;EACA,iFAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;AACF;AACE;EATF;IAUI,WAAA;EAEF;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEJ;AAAI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gCAAA;AAEN;AAAM;EACE,WAAA;EACA,YAAA;AAER;AAIE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAFJ;AAKI;EARF;IASI,mBAAA;EAFJ;AACF;AAKI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;AAHN;AAQI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AANN;AAWE;EACE,aAAA;EACA,mCAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;AATJ;AAWI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AATN;AAYI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAVN;AAcE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;AAZJ;AAqBA;EACE,kBAAA;EACA,eAAA;AAnBF;AAqBE;EAJF;IAKI,gBAAA;EAlBF;AACF;;AAwBA;EACE,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;EACA,qBAAA;EACA,kDAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;AArBF;AAuBE;EACE,aAAA;EACA,sBAAA;AArBJ;AAwBE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;AAtBJ;AAwBI;EACE,kBAAA;AAtBN;AAuBM;EACE,mBAAA;AArBR;AAuBM;EACE,uBAAA;AArBR;AAyBI;EACE,oBAAA;AAvBN;AA0BI;EACE,yBAAA;AAxBN;AA0BM;EACE,cAAA;AAxBR","sourcesContent":[".store-card {\n  width: calc(33% - .75rem);\n  background: var(--white);\n  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);\n  border-radius: .5rem;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n\n  &-image {\n    width: 100%;\n    height: 310px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      border-radius: 0.5rem 0.5rem 0 0;\n\n      &.preview {\n        width: 4rem;\n        height: 4rem;\n      }\n    }\n  }\n\n\n  &-more {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    margin-top: 5rem;\n\n\n    @media (max-width: 768px) {\n      margin-bottom: 5rem;\n    }\n\n\n    &-title {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 17px;\n      color: var(--black9);\n      margin-bottom: .5rem;\n      margin-top: 1.5rem;\n    }\n    &-icon {\n\n    }\n    &-description {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 13px;\n      line-height: 18px;\n      color: var(--black4);\n      text-align: center;\n    }\n  }\n\n\n  &-footer {\n    padding: 1rem;\n    border-top: 1px solid var(--black2);\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n\n    &-name {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 17px;\n      color: var(--black9);\n      margin-bottom: .25rem;\n    }\n\n    &-version {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 13px;\n      line-height: 16px;\n      color: var(--black5);\n    }\n  }\n\n  &-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    width: 100%;\n\n    @media (max-width: 768px) {\n\n    }\n  }\n}\n\n\n.more-buttons {\n  position: relative;\n  cursor: pointer;\n\n  @media (max-width: 768px) {\n    position: static;\n  }\n}\n\n\n\n\n.themes-buttons-dropdown {\n  position: absolute;\n  bottom: calc(100% + 0.5rem);\n  min-width: 250px;\n  max-width: 500px;\n  width: 100%;\n  background: var(--white);\n  border-radius: .5rem;\n  box-shadow: 0 4px 24px -4px rgb(18 20 23 / 8%);\n  right: 0;\n  padding: .5rem;\n  display: none;\n  z-index: 9;\n\n  &.open {\n    display: flex;\n    flex-direction: column;\n  }\n\n  button {\n    width: 100%;\n    border: none;\n    margin: 0 !important;\n    box-shadow: none !important;\n    align-items: center;\n    justify-content: flex-start;\n\n    &.delete-icon {\n      color: var(--red6);\n      svg * {\n        stroke: var(--red6);\n      }\n      &:hover {\n        background: var(--red0);\n      }\n    }\n\n    svg {\n      margin-right: .5rem;\n    }\n\n    &:hover {\n      background: var(--black1);\n\n      img {\n        display: block;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
